import {Button, Grid, TextField} from "@mui/material";
import {useState} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useTableRefresher} from "../../../../misc/scroller/Table";
import {logisticsTableName} from "./Logistics";
import {Loader} from "../../../../misc/Loader";
import {useProjectId} from "../ProjectName";
import {InventoryRequest} from "../../../../api/Logistics";
import {useSnackbar} from "../../../../misc/Snackbar";

export function canArchive(row: InventoryRequest) {
    return row.status !== "not-active";
}

export function ArchiveItemsForm(props: {
    type: string;
    rows: InventoryRequest[];
    onCancel(): void;
    onArchived(ids: number[]): void;
}) {
    const [note, setNote] = useState("");
    const project = useProjectId();
    const snack = useSnackbar();
    const refresher = useTableRefresher(logisticsTableName(project, props.type));
    const onArchived = props.onArchived;

    const archive = useAsyncAction(async (input: {project: number; ids: number[]; note: string}) => {
        const result = await api.logistics.archiveInventoryRequests(input);

        if(result.skipped.length > 0) {
            snack.success(`Archived ${result.archived.length} item(s). Skipped ${result.skipped.length} item(s) that can no longer be archived.`);
        }

        onArchived(input.ids);
        refresher();
    }, [refresher, snack, onArchived]);

    return <>
        <Loader {...archive} />
        <div style={{padding: 16, maxWidth: 400}}>
            This will set {props.rows.length} logistics item(s) to not-active.
            They will no longer show up in sourcing, packing or deliveries.
            <div style={{height: 16}} />
            <TextField onChange={e => setNote(e.target.value)} value={note} fullWidth label="Note (required)" />
        </div>
        <Grid container spacing={1} justifyContent="flex-end" style={{paddingRight: 10, paddingBottom: 8}}>
            <Grid item>
                <Button onClick={props.onCancel} size="small">Cancel</Button>
            </Grid>
            <Grid item>
                <Button onClick={() => archive.callback({
                    project: project,
                    ids: props.rows.map(v => v.id),
                    note: note,
                })} disabled={!note.trim()} variant="contained" size="small">Archive</Button>
            </Grid>
        </Grid>
    </>
}
